export { LastWinnerCard, type LastWinnerCardVariant } from './LastWinnerCard';
